import { createFileRoute } from '@tanstack/react-router';
import OrderKitsStore from '~/components/OrderKitsStore/OrderKitsStore';

export const Route = createFileRoute('/_authed/order-kits/store')({
  component: OrderKitsStore,
});
